import classNames from "classnames";
import CustomModal from "./CustomModal";
import { ModalBody, ModalFooter, Spinner } from "reactstrap";

import { Button } from "../Button";

import { ReactComponent as IconClose } from "../../assets/ic-close.svg";
import { noop } from "@helpers/common";

import styles from "./index.module.scss";

const Modal = ({
  isOpen,
  size,
  title,
  icon,
  children,
  confirmText,
  cancelText,
  className,
  bodyClassName,
  contentClassName,
  footerClassName,
  buttonsDisabled,
  cancelDisabled,
  cancelClassName,
  cancelButtonClassName,
  dialogClassName,
  closeClassName,
  closeContainerClassName,
  confirmClassName,
  titleClassName,
  submitDisabled,
  backdrop = true,
  unmountOnClose = false,
  fullscreen = false,
  showCancel = true,
  showConfirm = true,
  showClose = true,
  toggle,
  onClose = noop,
  onCancel = noop,
  onConfirm = noop,
  confirmType = "button",
  confirmForm,
  isPostModal,
  centered = true,
  scrollable,
  showConfirmButtonSpinner,
  buttonSize = "lg",
  iconClassName,
  backdropClassName,
  onOpened = noop,
  onClosed = noop,
}) => {
  const onToggle = toggle ?? onClose ?? noop;

  return (
    <CustomModal
      onClosed={onClosed}
      onOpened={onOpened}
      centered={centered}
      toggle={onToggle}
      backdrop={backdrop}
      size={size}
      isOpen={isOpen}
      className={dialogClassName}
      modalClassName={className}
      contentClassName={contentClassName}
      unmountOnClose={unmountOnClose}
      fullscreen={fullscreen}
      scrollable={scrollable}
      backdropClassName={backdropClassName}
    >
      {showClose && (
        <>
          <Button
            onClick={onClose}
            className={classNames(
              "position-absolute btn-resetStyle fit-content",
              isPostModal && "d-none d-xl-inline-block",
              isPostModal && styles.closePostModal,
              styles.close,
              styles.m12,
              closeClassName || "end-0",
              cancelButtonClassName,
            )}
          >
            <IconClose />
          </Button>
          <div
            className={classNames(
              !isPostModal && "d-none",
              isPostModal && "d-block d-xl-none",
              "position-sticky start-0 end-0 top-0 bg-inputs",
              styles.closeContainer,
              closeContainerClassName,
            )}
          >
            <Button
              onClick={onClose}
              className={classNames(
                "btn-resetStyle fit-content",
                styles.close,
                cancelButtonClassName,
              )}
            >
              <IconClose />
            </Button>
          </div>
        </>
      )}
      {icon && (
        <div
          className={classNames("mx-auto", styles.iconContainer, iconClassName)}
        >
          {icon}
        </div>
      )}
      {title && (
        <h4
          className={classNames(
            styles.title,
            "w-100 mb-0 h3-xl subtitle-1 text-center text-semibold text-primary",
            titleClassName,
          )}
        >
          {title}
        </h4>
      )}
      <ModalBody className={classNames("pb-0", bodyClassName)}>
        {children}
      </ModalBody>
      <ModalFooter
        className={classNames(
          "d-flex justify-content-center",
          styles.footer,
          footerClassName,
        )}
      >
        {showCancel && (
          <Button
            disabled={buttonsDisabled || cancelDisabled}
            size={buttonSize}
            className={classNames("m-0", styles.button, cancelClassName)}
            onClick={onCancel}
          >
            <span className="text-primary text-body-1 text-medium">
              {cancelText}
            </span>
          </Button>
        )}
        {showConfirm && (
          <Button
            size={buttonSize}
            className={classNames(
              styles.button,
              "my-0 me-0 text-medium ms-0 ms-xl-1",
              showCancel && "ms-xl-3",
              confirmClassName,
            )}
            color="primary"
            onClick={onConfirm}
            disabled={buttonsDisabled || submitDisabled}
            type={confirmType}
            form={confirmForm}
          >
            {showConfirmButtonSpinner ? (
              <Spinner className={styles.spinner} />
            ) : (
              confirmText
            )}
          </Button>
        )}
      </ModalFooter>
    </CustomModal>
  );
};

export default Modal;
